import { z } from "zod";

export const CustomFieldSchema = z.object({
  __typename: z.literal("CustomField").optional(),
  id: z.string(),
  ownerId: z.string(),
  ownerType: z.string(),
  workspaceId: z.string(),
  label: z.string(),
  value: z.string().nullable().optional(),
  order: z.number().int(),
  createdAt: z.union([z.date(), z.string()]),
  updatedAt: z.union([z.date(), z.string()]),
});

export type CustomField = z.infer<typeof CustomFieldSchema>;
